import PropTypes from "prop-types";

/*
 * Says plainly when a section is showing everything the API can give it.
 * Used where the reference design assumes fields the backend does not have.
 */
const Notice = ({ tone = "info", children }) => (
  <p className={`c4prf__notice c4prf__notice--${tone}`}>
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.7" />
      <path
        d="M12 11v5M12 8h.01"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
      />
    </svg>
    <span>{children}</span>
  </p>
);

Notice.propTypes = {
  tone: PropTypes.oneOf(["info", "secure"]),
  children: PropTypes.node,
};

export default Notice;
